import React, { useState, useEffect, useRef } from 'react';
import API from '../../utils/api';
import './CertificatesView.css';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

function CertificatesView() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStudent, setSelectedStudent] = useState(null);
  
  const role = localStorage.getItem('role');
  const branchId = localStorage.getItem('branchId');

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    setLoading(true);
    try {
      // If branch admin, fetch only for their branch, super admin gets all
      const url = (role !== 'Super Admin' && branchId) 
        ? `/api/admin/students?branchId=${branchId}` 
        : '/api/admin/students';
      
      const res = await API.get(url);
      setStudents(res.data);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch students:', error);
      setLoading(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const filteredStudents = students.filter(student => 
    student.name?.toLowerCase().includes(searchTerm.toLowerCase()) || 
    student.course?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="admin-view certificates-view-container">
      <div className="header-actions">
        <h2>Generate Certificates</h2>
        <input 
          type="text" 
          placeholder="Search by name or course..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="table-box mt-4">
        {loading ? (
          <p style={{ padding: '20px', textAlign: 'center' }}>Loading students...</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Student Name</th>
                <th>Course</th>
                <th>Branch</th>
                <th>Enrollment Date</th>
                <th>Fee Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredStudents.map(student => (
                <tr key={student._id}>
                  <td style={{ fontWeight: '600', color: '#0f172a' }}>{student.name}</td>
                  <td>{student.course}</td>
                  <td>{student.branch || 'N/A'}</td>
                  <td>{student.enrollmentDate ? new Date(student.enrollmentDate).toLocaleDateString('en-IN') : 'N/A'}</td>
                  <td>
                    <span className={student.status === 'Completed' || student.status === 'Paid' ? 'status-active' : student.status === 'Pending' ? 'status-inactive' : 'status-partial'}>
                      {student.status || 'Pending'}
                    </span>
                  </td>
                  <td>
                    <button 
                      className="generate-cert-btn"
                      onClick={() => setSelectedStudent(student)}
                    >
                      Generate Certificate
                    </button>
                  </td>
                </tr>
              ))}
              {filteredStudents.length === 0 && (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '30px', color: '#64748b' }}>
                    No students found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Certificate Modal */}
      {selectedStudent && (
        <div className="certificate-modal-overlay">
          <div className="certificate-modal-content">
            <div className="modal-header no-print">
              <h3>Certificate Preview</h3>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button className="print-btn" onClick={handlePrint}>Print / Save as PDF</button>
                <button className="close-btn" onClick={() => setSelectedStudent(null)}>&times;</button>
              </div>
            </div>
            
            {/* The Certificate Template */}
            <div className="certificate-container" id="printable-certificate">
              <div className="certificate-inner">
                
                <div className="cert-header">
                  <img 
                    src="/webmok-logo.png" 
                    alt="WebMok Logo" 
                    className="cert-logo"
                    onError={(e) => { e.target.onerror = null; e.target.style.display = 'none'; }} 
                  />
                  <h1 className="cert-title">CERTIFICATE</h1>
                  <h2 className="cert-subtitle">OF COMPLETION</h2>
                </div>

                <div className="cert-body">
                  <p className="cert-text">This certificate is proudly presented to</p>
                  <h2 className="cert-student-name">{selectedStudent.name}</h2>
                  <p className="cert-text">in recognition of successfully completing the</p>
                  <h3 className="cert-course-name">{selectedStudent.course}</h3>
                  <p className="cert-text">training program with outstanding dedication and performance.</p>
                </div>

                <div className="cert-footer">
                  <div className="cert-signature-box">
                    <div className="cert-line"></div>
                    <p>Date of Issue</p>
                    <p style={{ fontWeight: '600', color: '#1e293b' }}>
                      {new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}
                    </p>
                  </div>
                  
                  <div className="cert-badge">
                    <div className="badge-inner">
                      <span>VERIFIED</span>
                    </div>
                  </div>

                  <div className="cert-signature-box">
                    <div className="cert-line"></div>
                    <p>Authorized Signature</p>
                    <p style={{ fontWeight: '600', color: '#1e293b' }}>Director, WebMok</p>
                  </div>
                </div>

              </div>
            </div>
            
          </div>
        </div>
      )}
    </div>
  );
}

export default CertificatesView;
